import { alias, object, primitive, serializable } from "serializr";
import { ExerciseModal } from "../../ExerciseModal/Exercise.model";
import QuestionModel from "../../ExerciseModal/Question.model";

export class ExamExerciseModel {

    @serializable(alias('title', primitive()))
    title?: string;

    @serializable(alias('description', primitive()))
    description?: string;

    @serializable(alias('timer_options', primitive()))
    timerOptions?: string;

    @serializable(alias('time', primitive()))
    time?: Float32Array;

    @serializable(alias('is_active', primitive()))
    isActive?: boolean = false;

    @serializable(alias('position', primitive()))
    position?: number;

    @serializable(alias('exam_chapter_id', primitive()))
    examChapterId?: number;

    @serializable(alias('questions', object(QuestionModel)))
    questions?: any;

    @serializable(alias('excercise_id', primitive()))
    exerciseId?: boolean = false;

    @serializable(alias('attachment_url', primitive()))
    imageUrl?: any;

    @serializable(alias('excercise', object(ExerciseModal)))
    excercise?: ExerciseModal;
}
